// extracted by mini-css-extract-plugin
export var cardSelected = "_f2-2";
export var image = "_f2-1";
export var table = "_f2-0";